import {computed, Injectable, signal} from '@angular/core';
import {TicketHistoryEntry} from '../models/ticket-history.model';
import {TicketCategory} from '../models/ticket.model';

@Injectable({providedIn: 'root'})
export class NoCategoryHistoryContext {
	private readonly _history = signal<TicketHistoryEntry[]>([])

	readonly history = this._history.asReadonly()
	readonly canUndo = computed(() => this.history().length > 0)

	historyByCategory(category: TicketCategory) {
		return computed(() =>
			this.history().filter(h => h.to === category)
		)
	}

	add(entry: TicketHistoryEntry) {
		this._history.update(h => [...h, entry])
	}

	undoLast(): TicketHistoryEntry | null {
		let removed: TicketHistoryEntry | null = null;

		this._history.update(h => {
			if (h.length === 0) return h;
			removed = h[h.length - 1];
			return h.slice(0, -1)
		})

		return removed;
	}

	popTicket(ticketId: string): TicketHistoryEntry | null {
		let removed: TicketHistoryEntry | null = null;

		this._history.update(h => {
			const idx = h.findIndex(e => e.ticketId === ticketId);
			if (idx === -1) return h;

			removed = h[idx];
			return h.filter((_, i) => i !== idx);
		});

		return removed;
	}


	clear() {
		this._history.set([])
	}
}
